<template>	
	<div class="fxsymbolPrice whiteBG radiusbold">
		<div>
			<div class="pricefeed scrollbar tradingIdeas">
				<div class="table-responsive">
                    <table class="table pmmTable">
                        <thead>
                            <tr>
                                <th>{{$t('symbol')}}</th>
                                <th>{{$t('fxLast')}}</th>
                                <th>{{ $t('fxChange') }}</th>
                                <th>{{ $t('fxChange') }}%</th>
                                <!-- <th>{{$t('change')}}%</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="Object.keys(user_isins).length!=0 " v-for="spreads,key,index in user_isins" @click.prevent="$parent.loadChart = spreads.other.isinid">
                                <td valign="middle">{{spreads.other.isinid}}</td>
                                <td :class="[{'green': spreads.buy_increase_staus}, {'red': !spreads.buy_increase_staus}]">{{spreads.B}}</td>
                                <td :class="(spreads.B-spreads.other.closepx >= 0)?'green':'red'">{{flotData(spreads.B-spreads.other.closepx)}}</td>
                                <td :class="(((spreads.B-spreads.other.closepx)/spreads.other.closepx)*100 >= 0)?'green':'red'">
                                    {{flotData((spreads.B-spreads.other.closepx)/spreads.other.closepx * 100)}}%
                                </td>
                            </tr>
                            <tr v-if="Object.keys(user_isins).length == 0">
                                <td colspan="4" class="text-center">{{$t('fxPleaseWaitLoading')}}</td>
                            </tr>
                        </tbody>
                    </table>            
                </div>
			</div>
		</div>
	</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'

    //  import { Const } from '@/plugins/vue-provider-cache/const.mod'
    export default {
        name: 'Price-feed',

        data() {
            return {
                pageLoader : false,
                fxsymbolprice : 0,
                type: 'f'
            }
        },
        methods:{
            flotData(value){
                try{
                    if(parseFloat(parseFloat(value).toFixed(2).replace(/[.,]00$/, "")) != 0){
                        return parseFloat(value).toFixed(2).replace(/[.,]00$/, "")
                    }else{
                        return parseFloat(value).toFixed(3).replace(/[.,]000$/, "")
                    }
                }catch(e){
                    return value
                }
            }
        },
        computed: {
            user_isins() {
              try {
                // just 'feel' the pulse here so we get a reactive response
                // as the cache is not reactive  
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.currencyAll()
              } catch (ex) {
                // console.log('OO-one [ex]', ex)
                return {}
              }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/price_feed.vue